import React, { Component } from 'react'
import { Modal, Checkbox, message } from 'antd';
const CheckboxGroup = Checkbox.Group;

const finOptions = [
    
    { label: '合同财务收入（按JDE项目号）', value: 'INV_Contract_Jde'},
    { label: '项目财务收入（按JDE主项目号）', value: 'INV_Contract_MainJde'},
    { label: '当月新增合同', value: 'INV_New_Finance_Contract'},
    { label: '当月提前上岗合同', value: 'INV_Early_Employment'},
    { label: '累计提前上岗合同', value: 'INV_Total_Early_Employment'},
    { label: '经调整的在手订单额报告', value: 'INV_AdjustReport' },
];

const siteOptions = [
    { label: '中心收入分析明细', value: 'SITE_Analysis_Detail' },
    { label: '中心收入分析（按医院分析）', value: 'SITE_Analysis_Area' },
    { label: '中心收入分析（按城市分析）', value: 'SITE_Analysis_City' },
    { label: '经调整的在手订单额报告', value: 'SITE_AdjustReport' },
];

export default class ExportModal extends Component {
    state = {
        visible: false,
        value: [],
        type: null,
    }

    show = type => {
        this.setState({ visible: true, type })
    }
    
    handleOk = () => {
        const { value, type } = this.state;
        if(value.length) {
            this.props.export( type, value);
            this.handleCancel()
        } else {
            message.warning('请选择导出内容')
        }
    }

    handleCancel = () => {
        this.setState({ 
            visible: false,
            value: [],
            type: null,
        })
    }

    onChange = value => {
        this.setState({ value })
    }

    render() {
        const { visible, value } = this.state;
        const { activeKey } = this.props; 
        return (
        <Modal
            title="明细导出"
            visible={visible}
            onOk={this.handleOk}
            width={450}
            onCancel={this.handleCancel}
        >
            <p>请选择导出内容</p>
            <div style={{ width: '240px', margin: '10px 30px', lineHeight: '30px'}}>
                <CheckboxGroup value={value} options={activeKey == 'financeIncome' ? finOptions : siteOptions} onChange={this.onChange} />
            </div>
            <div style={{ color: '#ffbf00' }}>
                <p>经调整的在手订单额报告说明：</p>
                <p>1）计收入确认方式=开票的合同，在手订单额通过合同请款节点进行计算；</p>
                {
                    activeKey == 'financeIncome' ? 
                        <p>2）计收入确认方式≠开票的合同，在手订单额通过完工进度、预估FTE等方面进行计算；</p>
                    :
                        <p>2）计收入确认方式≠开票的合同，在手订单额通过预估FTE进行计算；</p>
                }
            </div>
        </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/homePage/FinanceIndicatorAnalysis/components/ExportModal.js